import { useEffect, useState } from 'react';
import type { CollectClient } from '../lib/api';
import { isAuthError } from '../lib/connection';

type Status = 'unknown' | 'online' | 'offline' | 'blocked' | 'auth-error' | 'error';

export function ConnectionStatus({ client, refreshKey }: { client: CollectClient; refreshKey?: number }) {
  const [status, setStatus] = useState<Status>('unknown');
  const [info, setInfo] = useState<string>('');

  useEffect(() => {
    let cancelled = false;
    setStatus('unknown');
    setInfo('');
    client.health()
      .then(() => {
        if (cancelled) return;
        setStatus('online');
        // Plain words only: this indicator is on the sign-in screen too, and the health
        // answer names internal services and storage (operators read /api/collect/health).
        setInfo('The Collect server answers.');
      })
      .catch((e: any) => {
        if (cancelled) return;
        if (e.code === 'NETWORK' || e.code === 'UNAVAILABLE') {
          setStatus('offline');
        } else if (e.code === 'CORS_BLOCKED') {
          setStatus('blocked');
        } else if (isAuthError(e)) {
          setStatus('auth-error');
        } else {
          setStatus('error');
        }
        setInfo(e.code === 'NETWORK' || e.code === 'UNAVAILABLE' || e.code === 'CORS_BLOCKED' ? e.message : `${e.code}: ${e.message}`);
      });
    return () => { cancelled = true; };
  }, [client, refreshKey]);

  const cls = status === 'online' ? 'online' : status === 'offline' ? 'offline' : 'error';
  const label = {
    unknown: 'connecting',
    online: 'connected',
    offline: 'offline',
    blocked: 'blocked (CORS)',
    'auth-error': 'auth error',
    error: 'server error',
  }[status];

  return (
    <div className="flex items-center gap-2" title={info}>
      <span className={`conn-dot ${cls} ${status === 'online' ? 'heartbeat' : ''}`}></span>
      <span className="label" style={{ color: status === 'online' ? '#34D399' : status === 'offline' ? '#9CA3AF' : '#F87171' }}>{label}</span>
    </div>
  );
}
